// Google Ads / GA4 conversion tracking. Uses the gtag base already loaded in index.html.
// Fires the "conversion_event_purchase" conversion ONLY when a purchase actually completes.
// Safe no-op if gtag hasn't loaded (e.g. blocked by an ad-blocker).
export function trackPurchase({ value, currency = "USD", transactionId, itemType } = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion_event_purchase", {
    value: typeof value === "number" ? value : undefined,
    currency,
    transaction_id: transactionId,
    item_type: itemType,
  });
}
